import React from "react";
import { ToastContainer, toast } from "react-toastify";
import { AiFillCheckCircle, AiFillCloseCircle, AiFillInfoCircle, AiFillWarning } from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";

const icons = {
  success: <AiFillCheckCircle size={24} />,
  error: <AiFillCloseCircle size={24} />,
  info: <AiFillInfoCircle size={24} />,
  warning: <AiFillWarning size={24} />,
};

export const showToast = (type, message) => {
  toast[type](
    <div className="flex items-center gap-3">
      <div className="toast-icon">{icons[type]}</div>
      <span className="toast-message">{message}</span>
    </div>
  );
};

const ToastProvider = () => (
  <ToastContainer
    position="top-right"
    autoClose={3000}
    hideProgressBar={false}
    newestOnTop
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
    toastClassName="custom-toast"
    progressClassName="toast-progress"
    bodyClassName="toast-body"
  />
);

export default ToastProvider;